<template>
  <footer class="footer" style="font-size:12px">
    created by
    <span> <a href="https://github.com/kebele">kemal beler</a> </span> with
    VueJs
  </footer>
</template>
